var main = {
  host: "/",
  language: "es",
  activeUrl: "/",
  init: function () {
    main.stickitHeader();
    main.animationBlock();
    main.screenFull();
    main.progressCircle();
    main.selectCountry();
    main.modalLoginRegRec();
    main.menuMovil();
    main.sidebarStickit();
    main.changeProfile();
    main.countHourSet();
    main.attachFile();
    main.sliderProgressCourse();
    main.choseCombo();
    main.anclaBlock();
    main.checkedBtn();
    main.newsletter();
    main.menuNew();
    main.inputPhoneList();
    //main.fixedVideo();
    $('[data-toggle="tooltip"]').tooltip();
  },
  socialWindow: function (a, b) {
    b.preventDefault();
    var left = (screen.width - 570) / 2;
    var top = (screen.height - 570) / 2;
    var params =
      "menubar=no,toolbar=no,status=no,width=570,height=570,top=" +
      top +
      ",left=" +
      left;
    // Setting 'params' to an empty string will launch
    // content in a new tab or window rather than a pop-up.
    // params = "";
    var url = a.getAttribute("href");
    window.open(url, "NewWindow", params);
  },
  getUri: function (uri) {
    return "/" + main.language + uri;
  },
  formContact: function () {
    $("#formContact").validate({
      rules: {
        name: "required",
        lastname: "required",
        email: { required: true, email: true },
        phone: "required",
        message: "required",
        profession: "required",
      },
      messages: {
        name: "Ingrese su nombre",
        lastname: "Ingrese su apellido",
        email: "Ingresa una direccion de correo electrónico",
        phone: "Ingrese su número de telefóno",
        message: "Ingrese su mensaje",
        profession: "Profesion",
      },
      errorPlacement: function (error, element) {
        error.insertBefore(
          $(element)
            .parents(".cnt-content-list-e")
            .find(".error-cnt")
            .html(error)
        );
      },
      submitHandler: function (form) {
        var params = $("#formContact").serialize();
        $.ajax({
          url: "/es/page/send-contact",
          data: params,
          type: "POST",
          dataType: "json",
          beforeSend: function (xhr) {},
          success: function (data) {
            if (data.success) {
              $("#formContact").html(
                "<p>Gracias, pronto nos contactaremos con usted</p>"
              );
            } else {
              $("#formContact").html(
                "<p>Error de conexión intentelo en unos minutos</p>"
              );
            }
          },
        });
        return false;
      },
    });
    return false;
  },
  newsletter: function () {
    $("#form-suscribete").validate({
      rules: {
        email: {
          required: true,
          email: true,
        },
      },
      messages: {
        email: {
          required: "Por favor ingresa su Email",
        },
      },
      errorPlacement: function (error, element) {
        error.insertBefore(
          $(element)
            .parents(".cnt-content-list-e")
            .find(".error-cnt")
            .html(error)
        );
      },
      submitHandler: function (form) {
        var params = $("#form-suscribete").serialize();
        $.ajax({
          url: "/es/page/newsletter",
          data: params,
          type: "POST",
          dataType: "json",
          beforeSend: function (xhr) {
            $("#newsletter-confirm").html("");
          },
          success: function (data) {
            if (data.success) {
              $("#idDivNewletterResponse").html(
                "<p>Gracias por suscribirte</p>"
              );
            } else {
              $("#idDivNewletterResponse").html(
                "<p>Gracias por suscribirte</p>"
              );
            }
          },
        });
        return false;
      },
    });
    return false;
  },
  anclaBlock: function () {
    $(".blockAncla").click(function (e) {
      e.preventDefault();
      var strAncla = $(this).attr("href");
      $("body,html")
        .stop(true, true)
        .animate(
          {
            scrollTop: $(strAncla).offset().top - 85,
          },
          1000
        );
    });
  },
  checkedBtn: function () {
    $(".checked-active").click(function (e) {
      if ($(this).is(":checked")) {
        $("#paymentOrder").removeClass("not-link");
      } else {
        $("#paymentOrder").addClass("not-link");
      }
    });
  },
  suscribe: function (publicationId, itemId, type, quantity) {
    var params = {
      activeUrl: main.activeUrl,
      publicationId: publicationId,
      itemId: itemId,
      type: type,
      quantity: quantity,
    };
    $.ajax({
      url: main.getUri("/suscription/suscriber"),
      data: params,
      type: "POST",
      dataType: "json",
      success: function (data) {
        $("#form-login").find(".btn-l-primary").removeClass("block-btn-load");
        if (data.success == true) {
          location.href = data.uri;
        } else {
          $("#idMessageLogin")
            .show()
            .addClass("block-error")
            .html(data.message);
        }
      },
      error: function (xhr, status) {},
    });
  },
  stickitHeader: function () {
    if ($(".nav-header").length) {
      $(".nav-header").stickit({ extraHeight: 0 });
    }
    if ($(".nav-header-n").length) {
      $(".nav-header-n").stickit({ extraHeight: 0 });
    }
  },
  choseCombo: function () {
    $(".chosen-select").chosen();
  },
  animationBlock: function () {
    AOS.init();
  },
  sidebarStickit: function () {
    if ($(".sidebar-stickit").length) {
      $(".sidebar-stickit").stickit({ screenMinWidth: 992 });
    }
  },
  menuNew: function () {
    if ($(".main-nav-m").length) {
      const toggleButton = document.getElementById("button-menu");
      const navWrapper = document.getElementById("nav-custom-m");
      const navClose = document.getElementById("close-nav-ico");

      toggleButton.addEventListener("click", () => {
        toggleButton.classList.toggle("close-nav");
        navWrapper.classList.toggle("show");
      });

      navWrapper.addEventListener("click", (e) => {
        if (e.target.id === "nav") {
          navWrapper.classList.remove("show");
          toggleButton.classList.remove("close-nav");
        }
      });

      navClose.addEventListener("click", () => {
        navWrapper.classList.remove("show");
        toggleButton.classList.remove("close-nav");
      });
    }
  },
  menuMovil: function () {
    if ($(".nav-header").length) {
      var fixed = document.querySelector(".nav-header");
      if ($(".all-header-count").length) {
        var cintBlock = document.querySelector(".all-header-count");
      }
      if ($(".block-logo").length) {
        var logoBlock = document.querySelector(".block-logo");
      }
      if ($(".block-app").length) {
        var logoBlock = document.querySelector(".block-app");
      }
      var slideout = new Slideout({
        panel: document.getElementById("main"),
        menu: document.getElementById("menu"),
        side: "right",
      });
      document
        .querySelector(".toggle-button")
        .addEventListener("click", function () {
          slideout.toggle();
        });

      slideout.on("translate", function (translated) {
        fixed.style.transform = "translateX(-" + translated + "px)";
        if ($(".all-header-count").length) {
          cintBlock.style.transform = "translateX(-" + translated + "px)";
        }
        if ($(".block-logo").length) {
          logoBlock.style.transform = "translateX(-" + translated + "px)";
        }
        if ($(".block-app").length) {
          logoBlock.style.transform = "translateX(-" + translated + "px)";
        }
      });

      slideout.on("beforeopen", function () {
        fixed.style.transition = "transform 300ms ease";
        fixed.style.transform = "translateX(-256px)";
        if ($(".all-header-count").length) {
          cintBlock.style.transition = "transform 300ms ease";
          cintBlock.style.transform = "translateX(-256px)";
        }
        if ($(".block-logo").length) {
          logoBlock.style.transition = "transform 300ms ease";
          logoBlock.style.transform = "translateX(-256px)";
        }
        if ($(".block-app").length) {
          logoBlock.style.transition = "transform 300ms ease";
          logoBlock.style.transform = "translateX(-256px)";
        }
      });

      slideout.on("beforeclose", function () {
        fixed.style.transition = "transform 300ms ease";
        fixed.style.transform = "translateX(0px)";
        if ($(".all-header-count").length) {
          cintBlock.style.transition = "transform 300ms ease";
          cintBlock.style.transform = "translateX(0px)";
        }
        if ($(".block-logo").length) {
          logoBlock.style.transition = "transform 300ms ease";
          logoBlock.style.transform = "translateX(0px)";
        }
        if ($(".block-app").length) {
          logoBlock.style.transition = "transform 300ms ease";
          logoBlock.style.transform = "translateX(0px)";
        }
      });
    }
  },
  screenFull: function () {
    if ($("#screenFull").length) {
      var activeScreen = true;
      $(".screen-full").click(function () {
        if (activeScreen == true) {
          $(this).addClass("screen-cont");
          $("#block-screen").removeClass("cont-block-right");
          if ($(".video-screen").length) {
            $(".video-fixed").stickit("destroy");
          }
          activeScreen = false;
        } else {
          $(this).removeClass("screen-cont");
          $("#block-screen").addClass("cont-block-right");
          if ($(".video-screen").length) {
            $(".video-fixed").stickit({ screenMinWidth: 992, top: 65 });
          }
          activeScreen = true;
        }
      });
    }
  },
  fixedVideo: function () {
    if ($(".video-fixed").length) {
      $(".video-fixed").stickit({ screenMinWidth: 992, top: 65 });
    }
  },
  progressCircle: function () {
    if ($("#circleProgress").length) {
      $(".progress-bar-cir").loading();
    }
  },
  selectCountry: function () {
    if ($("#inputPhoneNumber").length) {
      var inputPhoneNumber = document.querySelector("#inputPhoneNumber");
      var countryCode = $("#inputPhoneNumber").data("country");
      if (countryCode == "") {
        countryCode = "pe";
      }

      var intPhoneNumber = intlTelInput(inputPhoneNumber, {
        initialCountry: countryCode,
        //utilsScript: main.host + "dist/js/utils.js",
        utilsScript:
          "https://intl-tel-input.com/intl-tel-input/js/intlTelInput.js?1687509211722",
        preferredCountries: ["pe", "co", "mx", "ar", "es", "us"],
        placeholderNumberType: "MOBILE",
        separateDialCode: true,
      });
    }
  },
  modalLoginRegRec: function () {
    $("#loginModal").on("show.bs.modal", function (e) {
      $("#registrameModal").modal("hide");
      $("#recoveryModal").modal("hide");
    });
    $("#registrameModal").on("show.bs.modal", function (e) {
      $("#loginModal").modal("hide");
      $("#recoveryModal").modal("hide");
    });
    $("#recoveryModal").on("show.bs.modal", function (e) {
      $("#loginModal").modal("hide");
      $("#registrameModal").modal("hide");
    });
  },
  startCal: function () {
    if ($(".list-question").length) {
      $("#calificacionModal").modal({
        show: true,
        backdrop: "static",
      });

      var eventL = $(".star-list i");
      eventL.click(function (e) {
        if ($(this).parent(".star-list").data("calif")) {
          $(this).parent(".star-list").data("calif", false);
          $(this).parent(".star-list").find("i").removeClass("active");
          $(this).addClass("active");
          var pointCalif = $(this).data("point");
          var publicationId = og.params.productoId;
          var indicatorId = $(this).data("id");

          $.ajax({
            url: main.getUri("/class-room/save-valoration"),
            type: "POST",
            dataType: "json",
            data: {
              value: pointCalif,
              publicationId: publicationId,
              indicatorId: indicatorId,
            },
            success: function (data) {
              var html = "";
              if (data.success) {
              }
            },
          });
        }
      });
    }
  },
  changeProfile: function () {
    if ($("#uploadImg").length) {
      function readURL(input) {
        if (input.files && input.files[0]) {
          var reader = new FileReader();
          reader.onload = function (e) {
            $("#profileImg").attr("src", e.target.result);
          };
          reader.readAsDataURL(input.files[0]);
        }
      }

      $("#uploadImg").change(function () {
        readURL(this);
      });
    }
  },
  countHourSet: function () {
    if ($("#numCountDown").length) {
      var count = $("#numCountDown").data("timesecond");

      toHHMMSS = function (timeS) {
        var sec_num = parseInt(timeS, 10); // don't forget the second parm
        var hours = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - hours * 3600) / 60);
        var seconds = sec_num - hours * 3600 - minutes * 60;

        if (hours < 10) {
          hours = "0" + hours;
        }
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        if (seconds < 10) {
          seconds = "0" + seconds;
        }
        var time = hours + ":" + minutes + ":" + seconds;
        return time;
      };

      var counter = setInterval(timer, 1000);

      function timer() {
        if (parseInt(count) < 0) {
          clearInterval(counter);
          return;
        }
        var temp = toHHMMSS(count);
        count = (parseInt(count) - 1).toString();

        $("#numCountDown").html(temp);
      }
    }
  },
  showPostWp: function () {
    $.get("/page/feed", function (xml) {
      if (xml.success) {
        var i = 0;
        var j = 0;
        $.each(xml.data, function (key, value) {
          if (i > 5) {
            return;
          }
          var title = value.title;
          var date = value.pubDate;
          var description = value.description;
          var link = value.link;
          var creator = value.creator;
          var image = value.post_thumbnail;
          if (i == 0) {
            var section = $("#idWSeccion1");
            $(section.find("h2")).text(title);
            $(section.find("p")).text(description);
            //$(section.find("a")).css('background',"url("+image+")");
            var enlace = $(section.find("a")).attr("href", link);
          } else if (i == 1) {
            var section = $("#idWSeccion2");
            $(section.find("h2")).text(title);
            //$(section.find("a")).css('background',"url("+image+")");
            var enlace = $(section.find("a")).attr("href", link);
          } else if (i == 2) {
            var section = $("#idWSeccion4");
            $(section.find("h2")).text(title);
            //$(section.find("a")).css('background',"url("+image+")");
            var enlace = $(section.find("a")).attr("href", link);
          } else {
            var section = $("#idWSeccion3");
            $(section.find("h2 a")[j]).text(title);
            $(section.find("h2 a")[j]).attr("href", link);

            date = Date.parse(date);
            date = new Date(date);
            var monthNames = [
              "Enero",
              "Febrero",
              "Marzo",
              "Abril",
              "Mayo",
              "Junio",
              "Julio",
              "Agosto",
              "Septiembre",
              "Octubre",
              "Noviembre",
              "Diciembre",
            ];
            var day = date.getDate();
            var monthIndex = date.getMonth();
            var year = date.getFullYear();

            date = day + " " + monthNames[monthIndex] + " " + year;

            var fecha = $(section.find(".date-first")[j]).text(date);

            // Contar palabras para cortar el texto descriptivo en 30 palabras
            descripcion = [];
            description = description.split(" ");

            if (description.length >= 30) {
              for (k = 0; k <= 20; k++) {
                descripcion.push(description[k]);
              }

              description = descripcion.join(" ");
              //description += "...";
            }
            description += " <a href=" + link + " target='blank'>Ver más</a>";
            $(section.find("span")[j]).html(description);
            j = j + 1;
          }
          i++;
        });
      }
    });
  },
  attachFile: function () {
    var inputs = document.querySelectorAll(".inputfile");
    Array.prototype.forEach.call(inputs, function (input) {
      var label = input.nextElementSibling,
        labelVal = label.innerHTML;

      input.addEventListener("change", function (e) {
        var fileName = "";
        if (this.files && this.files.length > 1)
          fileName = (this.getAttribute("data-multiple-caption") || "").replace(
            "{count}",
            this.files.length
          );
        else fileName = e.target.value.split("\\").pop();

        if (fileName) label.querySelector("span").innerHTML = fileName;
        else label.innerHTML = labelVal;
      });

      // Firefox bug fix
      input.addEventListener("focus", function () {
        input.classList.add("has-focus");
      });
      input.addEventListener("blur", function () {
        input.classList.remove("has-focus");
      });
    });
  },
  sliderProgressCourse: function () {
    if ($(".coursePC").length) {
      $(".coursePC").slick({
        arrows: true,
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        variableWidth: true,
        prevArrow:
          '<div class="arrow-my-c prev"><i class="fas fa-chevron-left"></i></div>',
        nextArrow:
          '<div class="arrow-my-c next"><i class="fas fa-chevron-right"></i></div>',
      });
    }
  },
  maskPlaceHolderPhone: function (id) {
    if ($("#" + id).length) {
      var phoneInputUser = document.querySelector("#" + id);
      var dataCountry = $("#" + id).data("country");
      if (dataCountry) {
        var intPhone = intlTelInput(phoneInputUser, {
          initialCountry: dataCountry,
          utilsScript: main.host + "dist/js/utils.js",
          preferredCountries: ["pe", "co", "mx", "ar", "es", "us"],
          placeholderNumberType: "MOBILE",
          separateDialCode: true,
        });
      } else {
        var intPhone = intlTelInput(phoneInputUser, {
          initialCountry: "pe",
          utilsScript: main.host + "dist/js/utils.js",
          preferredCountries: ["pe", "co", "mx", "ar", "es", "us"],
          placeholderNumberType: "MOBILE",
          separateDialCode: true,
        });
      }
    }
  },
  downSell: function () {
    $("#offertOneModal").modal("hide"); //ocultamos el modal
    $("body").removeClass("modal-open"); //eliminamos la clase del body para poder hacer scroll
    setTimeout(function () {
      $("#offertOneModal").remove();
      $("#offertTwoModal").modal("show");
    }, 350);
  },
  hideUpselling: function (type, publicationId, paId) {
    $.ajax({
      url: main.getUri("/complete/upselling"),
      type: "POST",
      dataType: "json",
      data: {
        publicationId: publicationId,
        paId: paId,
      },
      success: function (data) {
        if (data.success) {
        }
      },
    });
    if (type == "upsell") {
      $("#offertOneModal").modal("hide");
    } else if (type == "downsell") {
      $("#offertTwoModal").modal("hide");
      $("body").removeClass("modal-open");
    }
  },
  calendarReserve: function (
    _dayIni,
    _dayEnd,
    _quotesDisabled,
    _publicationId
  ) {
    // $('#reserveModal').on('shown.bs.modal', function () {

    // var dayIni = _dayIni;
    // var dayEnd = _dayEnd;
    // var quotesDisabled = ["2021-04-10","2021-04-11","2021-04-17","2021-04-18","2021-04-24","2021-04-25","2021-05-01","2021-05-02","2021-05-08","2021-05-09","2021-05-15","2021-05-16","2021-05-22","2021-05-23","2021-05-29","2021-05-30","2021-06-05","2021-06-06","2021-06-12","2021-06-13","2021-06-19","2021-06-20","2021-06-26","2021-06-27","2021-07-03","2021-07-04","2021-07-10","2021-07-11","2021-07-17","2021-07-18","2021-07-24","2021-07-25","2021-07-31","2021-08-01","2021-08-07","2021-08-08","2021-08-14","2021-08-15","2021-08-21","2021-08-22","2021-08-28","2021-08-29","2021-09-04","2021-09-05","2021-09-11","2021-09-12","2021-09-18","2021-09-19","2021-09-25","2021-09-26","2021-10-02","2021-10-03","2021-10-09","2021-10-10","2021-10-16","2021-10-17","2021-10-23","2021-10-24","2021-10-30","2021-10-31","2021-11-06","2021-11-07","2021-11-13","2021-11-14","2021-11-20","2021-11-21","2021-11-27","2021-11-28","2021-12-04","2021-12-05","2021-12-11"];
    // var quotesDisabled = _quotesDisabled;
    // console.log(_dayIni, _dayEnd, _quotesDisabled);
    //$('#datepickerMent').datepicker("update");
    var tZ = custom._timeZoneClient ? custom._timeZoneClient : custom._timeZone;
    $("#datepickerMent").remove();
    $(".body-calendar-reserv").append(
      '<div id="datepickerMent" class="custom-datepicker"></div>'
    );
    $("#datepickerMent")
      .datepicker({
        language: "es",
        todayHighlight: true,
        format: "yyyy-mm-dd",
        startDate: _dayIni,
        endDate: _dayEnd,
        datesDisabled: _quotesDisabled,
        beforeShowDay: function (date) {
          return { content: "<button>" + date.getDate() + "</button>" };
        },
      })
      .on("changeDate", function (e) {
        if (
          typeof _publicationId != "undefined" &&
          e.format("yyyy-mm-dd").length != 0
        ) {
          $.ajax({
            url: "/es/account/get-quotes-day",
            data: {
              publicationId: _publicationId,
              date: e.format("yyyy-mm-dd"),
              timeZone: tZ,
            },
            type: "GET",
            dataType: "json",
            headers: {
              Authorization: custom.token,
              "Content-Type": "application/json",
            },
            success: function (data) {
              if (data.success == true) {
                //$("#rTimezone").attr('disabled', 'disabled');
                var html = '<div class="clear-fix block-hour-resv">';
                html +=
                  "<h3>" +
                  data.data.date +
                  "</h3>" +
                  '<div class="clear-fix item-hour-resv">' +
                  "<h4>Horas disponibles</h4>" +
                  '<ul class="reset-ul">';
                $.each(data.data.quotes, function (index, value) {
                  html +=
                    "<li>" +
                    '<div class="clear-fix event-resv">' +
                    value.hourIni +
                    "</div>" +
                    '<div class="clear-fix resv-btn">' +
                    "<span>" +
                    value.hourIni +
                    "</span>" +
                    '<a data-date="' +
                    data.data.dateSend +
                    '" data-hourini="' +
                    value.hourIni +
                    '"  data-hourfin="' +
                    value.hourFin +
                    '"  data-publicationid="' +
                    data.data.publicationId +
                    '" href="javascript:void(0)" onclick="saveProdQuotDateTime(this, ' +
                    "'" +
                    data.data.dateSend +
                    "','" +
                    value.hourIni +
                    "','" +
                    value.hourFin +
                    "'" +
                    ')" class="btn-l-resv">Reservar</a>' +
                    "</div>" +
                    "</li>";
                });
                html += "</ul>" + "</div>" + "</div>";
                $("#listHourCalendar").html(html);
                $("#block-reserv-c").hide();
                $(".btn-return").show();
                $("#listHourCalendar").show();

                if ($(".footer-calendar-m").length) {
                  $(".hour-select").customSelect();
                }
                $(".event-resv").click(function () {
                  var eventR = $(this);
                  var parentUl = $(".item-hour-resv");

                  parentUl.find("ul li .resv-btn").hide();
                  parentUl.find("ul li .event-resv").show();

                  eventR.hide();
                  eventR.parent("li").find(".resv-btn").show();
                });
              }
            },
            error: function (xhr, status) {},
          });
          e.stopPropagation();
        }
        //console.log('cambiando fecha');
        //$("#block-reserv-c").hide();
        //$(".btn-return").show();
        //$("#listHourCalendar").show();
      });
    // });

    $(".btn-return").click(function (e) {
      e.preventDefault();
      $("#block-reserv-c").show();
      $("#listHourCalendar").hide();
      $(".btn-return").hide();
    });

    if ($("#listHourCalendar").length) {
      $(".event-resv").click(function () {
        var eventR = $(this);
        eventR.hide();
        eventR.parent("li").find(".resv-btn").show();
      });
    }
    $("#reserveModal").on("hidden.bs.modal", function (event) {
      $("#block-reserv-c").show();
      $("#listHourCalendar").hide();
      $(".btn-return").hide();
    });
  },
  inputPhoneList: function () {
    if ($("#inputContactPhone").length) {
      var inputContactPhone = document.querySelector("#inputContactPhone");
      var countryCode = $("#inputContactPhone").data("country");
      if (countryCode == "") {
        countryCode = "pe";
      }

      var intContactPhone = intlTelInput(inputContactPhone, {
        initialCountry: countryCode,
        //utilsScript: main.host + "dist/js/utils.js",
        utilsScript:
          "https://intl-tel-input.com/intl-tel-input/js/intlTelInput.js?1687509211722",
        preferredCountries: ["pe", "co", "mx", "ar", "es", "us"],
        placeholderNumberType: "MOBILE",
        separateDialCode: true,
      });
    }
  },
};
